import { computeFixedPopupPosition } from "shared/utils/fixedPopupPosition";

/**
 * Fixed position + width + viewport-safe max height for the rich event selector (Activity-style shell).
 */
export function getFixedPanelPositionFromRect(rect) {
  if (typeof window === "undefined") {
    return { top: 8, left: 8, width: 780, maxHeightPx: 420 };
  }
  if (!rect) {
    const vh = window.innerHeight;
    const vw = window.innerWidth;
    const margin = 12;
    const width = Math.min(920, Math.max(vw - 2 * margin, 320));
    const maxHeightPx = Math.min(Math.round(vh * 0.65), vh - 2 * margin);
    return { top: margin, left: margin, width, maxHeightPx };
  }
  const vw = window.innerWidth;
  const margin = 12;
  const width = Math.min(920, Math.max(vw - 2 * margin, 320));
  const pos = computeFixedPopupPosition(rect, {
    estimatedWidth: width,
    margin,
    gap: 8,
  });
  return {
    top: pos.top,
    left: pos.left,
    width,
    maxHeightPx: pos.maxHeightPx,
  };
}
